import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import getAppConfig from "../../../config/appConfig";
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import AAF from "src/AAF/AAF";
import { EPG_VERSION_TTL } from "../../../AAF/Resilence/TTLConstants";

const TTLItem = EPG_VERSION_TTL;
class LevelRibbonTask extends AbstractRequestTask {
  constructor(uri, params) {
    super();

    this.uri = uri;
    this.params = params;
    if (this.params.node_id === null) {
      delete this.params.node_id;
    }
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    return getAppConfig().end_point_middleware + this.uri;
    //return 'http://10.7.0.83:4000/webapi-video/level'
  }

  getParams() {
    const params = super.getParams();
    AAF.TTLUtil.verifyTTLItem(TTLItem, () => { AAF.TTLUtil.setEpgVersion(); }, 'LevelRibbonTask[getParams]');
    const epg_version = DeviceStorage.getItem('epgVersion');
    if(epg_version){
      params.epg_version = epg_version;
    }
    return Object.assign({}, params, this.params);
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default LevelRibbonTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/cms/LevelRibbonTask.js